import React, { Component } from 'react';

import './Footer.css';

import ProductPrice from './ProductPrice';
import { __ } from './../Translator';
import InlineSvg from "../InlineSvg";

import BackIcon from "./../img/icon-footer-back.svg";
import AppStore from "../flux/AppStore";
import currencySymbol from '../utils/currencySymbol';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      middle: props.middle,
      right: props.right,

      customProduct: AppStore.getCustomProduct(),
      selectedProduct: null,
      showNextButton: props.showNextButton,
    };

    this.onCustomProductChange = this.onCustomProductChange.bind(this);
  }

  componentDidMount() {
    AppStore.events.initCustomProduct.addListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductChange);
  }

  componentWillUnmount() {
    AppStore.events.initCustomProduct.removeListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductChange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      middle: nextProps.middle,
      right: nextProps.right,
      showNextButton: nextProps.showNextButton,
    });
  }

  onCustomProductChange() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  render() {
    return (
      <footer className="footer">
        <div className="row">
          <div className="col-xs-3">
            <div className="footer__legalLinks">
            <span>
              <a target="_blank" href="http://www.dainese.com/it/en/disclaimer.html">{__('Disclaimer')}</a>
            </span>
              |
              <span>
              <a target="_blank" href="https://policy.dainese.com/privacy">{__('Privacy policy')}</a>
            </span>
            </div>
          </div>
          <div className="col-xs-6">
            <div className="footer__navigator text-center">
              {this.state.middle ? (
                this.state.middle
              ) : (
                <div>
                  {this.props.showBackButton ? (
                    <button className="muted navigator__btn navigator__back" onClick={() => {
                      this.props.navigation.back();
                    }}>
                      {__('BackButton')}
                    </button>
                  ) : null}
{/* 
                  {this.state.showNextButton ? (
                    <button className={`muted navigator__btn navigator__next ${this.props.navigation.onNextCallback !== null ? 'is-highlighted' : ''}`} onClick={() => {
                      this.props.navigation.next();
                    }}>{__('Next')}</button>
                  ) : null} */}
                </div>
              )}
            </div>
          </div>
          <div className="col-xs-3">
            {this.state.right ? (
              this.state.right
            ) : (
              this.state.customProduct && this.props.showPrice && shouldShowPrice(CountryStore.getState()) ? (
                <div className="footer__productPrice">
                  <ProductPrice /> <span className="m--eur">{currencySymbol(this.state.customProduct.product.country_id)}</span>
                </div>
              ) : null
            )}
          </div>
        </div>
      </footer>
    );
  }
}

Footer.defaultProps = {
  showBackButton: true,
  showNextButton: true,
  showPrice: true,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js